
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32.82 27.16H14.08c-.6 0-.69-1.19-.69-1.58v-12.4c0-.37.09-1.58.69-1.58h18.74c.61 0 .7 1.18.7 1.58v11.87c.13.92-.1 2.11-.7 2.11zm-18.05-3.15h17.36v-9.26H14.77v9.26zM35.9 48.69h11.08c.59 0 .83-1.19.69-2.1V29.47c0-.39-.09-1.57-.69-1.57H35.9c-.6 0-.69 1.21-.69 1.57v17.61c0 .43.09 1.61.69 1.61zm10.38-3.15h-9.69V31.08h9.69v14.46zM32.9 48.69H14.08c-.64 0-.73-1.18-.69-1.61V29.47c0-.36.09-1.57.69-1.57h9.82c.6 0 .83 1.17.7 2.09v7.36h8.3c.6 0 .69 1.19.69 1.58v8.19c0 .36-.08 1.57-.69 1.57zm-.69-8.19h-8.35c-.6 0-.69-1.18-.65-1.54v-7.88h-8.43V45.5h17.43v-5z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.49 27.9a.41.41 0 00-.19 0c-.43.25-.59 1.24-.47 2v5.67c0 .39.09 1.58.69 1.58h7c.6 0 .69-1.22.69-1.58v-6.2c0-.39-.09-1.57-.69-1.57l-7.03.1zm.7 3.15h5.58v3.05h-5.58v-3.05zM46.98 27.16H35.9c-.6 0-.69-1.19-.69-1.58v-12.4c0-.37.09-1.58.69-1.58h11.08c.6 0 .69 1.18.69 1.58v11.87c.14.92-.1 2.11-.69 2.11zm-10.39-3.15h9.69v-9.26h-9.69v9.26z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M50.29 9.58v40.36c.13.91-.1 2.14-.69 2.1H10.69c-.6 0-.69-1.18-.69-1.57V9.58c0-.36.08-1.58.69-1.58H49.6c.6 0 .69 1.19.69 1.58zM11.38 48.89H48.9V11.15H11.38v37.74z"}})])
          )
        }
      }
    